'use strict';
///*------------------------------------------------
///* звонок на случайный номер из списка телефонов 
///*------------------------------------------------
const callToTelList = (() => {
  // The Phone numbers
  const phoneNumbers = [
      '+88462312591',
      '+89093292911',
    ],
    callButton = document.body.querySelector('#callPhone');
  /**
	 * Returns a random integer between min (inclusive) and max (inclusive)
	 * Using Math.round() will give you a non-uniform distribution!
	*/
  const getRandomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const call = (e) => {
    e.preventDefault();
    // Get min and max index of the phone number array
    const min = 0,
      max = phoneNumbers.length - 1,
      // get the random phone number
      phoneNumberToCall = phoneNumbers[getRandomInt(min, max)];
    // Call the random number
    window.open('tel:' + phoneNumberToCall);   
  };
  const handler = () => {   
    callButton.addEventListener('click', call);
  };
  return {handler};
})();

export default callToTelList;


// WEBPACK FOOTER //
// ./app/components/callToListPhones.js